import type { FC } from 'react';
import { Navigate, Route } from 'react-router';
import { useOptionalStorageServiceRoot } from 'src/apis/storage/use-storage-service-root';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RootRoutes } from 'src/components/root-routes';
import { PageSpinner } from 'src/components/spinner-container';
import { StorageLocationsOverview } from 'src/pages/storage/locations';
import { StorageLocationsNewRoot } from 'src/pages/storage/locations-new';
import { StorageOfferCards } from 'src/pages/storage/offer-cards';
import { StorageOffers } from 'src/pages/storage/offers';
import { StorageOffersNewRoot } from 'src/pages/storage/offers-new';

export const StorageRoot: FC = () => {
  const storageServiceRoot = useOptionalStorageServiceRoot();
  if (storageServiceRoot?.loaded === false) {
    return <PageSpinner />;
  }

  // Falls back to the monolith page when Storage Service is unreachable.
  // TODO: to be removed as part of the clean-up
  const locationsNewEnabled = Boolean(
    storageServiceRoot?.response?.data._links?.getLocationsOverviewPublic
  );

  return (
    <RootRoutes>
      {/* Old Storage - Monolith */}
      <Route
        path="/storage"
        element={
          <Navigate
            to={
              storageServiceRoot?.response?.data._links?.getSsoOfferCards
                ? '/storage/offer-cards'
                : '/storage/offers'
            }
            replace
          />
        }
      />
      <Route path="/storage/offer-cards" element={<StorageOfferCards />} />
      <Route path="/storage/offers" element={<StorageOffers />} />
      <Route
        path="/storage/locations/*"
        element={
          locationsNewEnabled ? (
            <StorageLocationsNewRoot />
          ) : (
            <StorageLocationsOverview />
          )
        }
      />

      {/* New Storage - Storage Service */}
      <Route path="/storage/offers-new/*" element={<StorageOffersNewRoot />} />

      <Route path="*" element={<ThrowNotFound />} />
    </RootRoutes>
  );
};
